<template>
  <div class="container" :style="{ backgroundImage: 'url(' + backgroundImage + ')' }">
    <!-- { color: activeColor, fontSize: fontSize + 'px' } -->
    <div class="door" v-for="door in doors" :key="door.day" :style="getDoorStyle(door)" @click="showDoorContent(door)"
      @mouseover="toggleDoor(door, true)" @mouseout="toggleDoor(door, false)">
      <div class="door-fold" :style="getBackgroundImageStyle(door.position)"
        :class="{ opened: openedDoor == door.day, locked: !door.image, sealed: !door.isOpened }">
        <span>{{ door.day }}</span>
      </div>
    </div>

    <template v-if="imagePreview">
      <div class="dialog-container">
        <div v-if="imagePreviewDescription" class="dialog-description" @click="imagePreviewDescription = ''">
          {{ imagePreviewDescription }}
        </div>
        <img class="dialog-image" :src="imagePreview" @click="imagePreview = ''">
      </div>
      <div class="dialog-shadow" @click="imagePreview = ''"></div>
    </template>

    <img id="background-image" :src="backgroundImage" @load="calcImagePosition()">
  </div>
</template>

<script>
const BASE_URL = 'https://api.timspickermann.de';

export default {
  name: 'calendar',
  data() {
    return {
      backgroundImage: '',
      doors: [],
      imagePosition: {},
      openedDoor: 0,
      imagePreview: '',
      imagePreviewDescription: '',
      accessToken: ''
    }
  },
  methods: {
    async init() {
      const url = `${BASE_URL}/items/AdventCalenderUser/?access_token=${this.accessToken}&fields=*,days.id,days.isOpened,days.AdventCalender_id.*,days.AdventCalender_id.image.*`;
      const calendar = (await fetch(url).then(res => res.json())).data[0];
      document.title = calendar.documentTitle;

      this.backgroundImage = `${BASE_URL}/assets/${calendar.backgroundImage}?access_token=${this.accessToken}`;

      const days = calendar.dayOrder.split(',').map(n => Number(n));
      const doors = [];
      for (let i = 0; i < 24; i++) {
        const door = {
          day: days[i],
          position: {
            x: 16 * (i % 6) + 4,
            y: 23.5 * Math.floor(i / 6) + 3.5,
            w: 12,
            h: 20,
            day: days[i]
          }
        };
        const data = calendar.days.find(el => el.AdventCalender_id ? Number(el.AdventCalender_id.day) === days[i] : false);
        if (data) {
          door.id = data.id;
          door.isOpened = data.isOpened;
          door.image = `${BASE_URL}/assets/${data.AdventCalender_id.image.id}?access_token=${this.accessToken}`;
          door.description = data.AdventCalender_id.description || data.AdventCalender_id.image.description;
        }
        doors.push(door);
      }
      this.doors = doors;
    },
    saveDoorOpened(door) {
      fetch(`${BASE_URL}/items/AdventCalenderUser_AdventCalender/${door.id}?access_token=${this.accessToken}`, {
        method: 'PATCH',
        body: JSON.stringify({ isOpened: true }),
        headers: {
          'content-type': 'application/json'
        }
      }).then(res => res.json()).then(console.log)
    },
    toggleDoor(door, state) {
      if (!this.imagePreview && door.image) {
        if (state) this.openedDoor = door.day;
        else this.openedDoor = 0;
      }
    },
    showDoorContent(door) {
      if (door.image) {
        if (!door.isOpened) {
          door.isOpened = true;
          this.saveDoorOpened(door);
        }
        this.toggleDoor(door.day, true);
        this.imagePreview = door.image;
        this.imagePreviewDescription = door.description;
      }
    },
    getDoorStyle(door) {
      return "top:" + door.position.y + "%;" +
        "left:" + door.position.x + "%;" +
        "width:" + door.position.w + "%;" +
        "height:" + door.position.h + "%;" +
        (door.image ? `background-image:url(${door.image}&key=advent-calender-door);` : "");
    },
    getBackgroundImageStyle(position) {
      var offsetLeft = this.imagePosition.left - position.x * window.innerWidth / 100;
      var offsetTop = this.imagePosition.top - position.y * window.innerHeight / 100;
      return "background-image:url(" + this.backgroundImage + ");" +
        "background-position:" + offsetLeft + "px " + offsetTop + "px;" +
        "background-size:" + this.imagePosition.width + "px " + this.imagePosition.height + "px;";
    },
    calcImagePosition() {
      var img = document.getElementById("background-image");
      var imgWidth = img.naturalWidth;
      var imgHeight = img.naturalHeight;
      var width = document.documentElement.clientWidth;//window.innerWidth;
      var height = document.documentElement.clientHeight;//window.innerHeight;
      if (width / height > imgWidth / imgHeight) {
        // Full width
        this.imagePosition = { top: (height - imgHeight * width / imgWidth) / 2, left: 0, width: width, height: imgHeight * width / imgWidth };
      } else {
        // Full height
        this.imagePosition = { top: 0, left: (width - imgWidth * height / imgHeight) / 2, width: imgWidth * height / imgHeight, height: height };
      }
    }
  },
  created() {
    if (location.pathname) {
      this.accessToken = location.pathname.slice(1);
      this.init();
    }
  },
  mounted() {
    window.addEventListener("resize", this.calcImagePosition);
    this.calcImagePosition();
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Fascinate+Inline');

.container {
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background-size: cover;
  background-position: center;
}

#background-image {
  display: none;
}

.door {
  position: fixed;
  background-color: #333;
  box-shadow: inset 0 0 1px black;
  -webkit-perspective: 800;
  cursor: pointer;
  background-size: cover;
  background-position: center;
}

.door-fold {
  width: 100%;
  height: 100%;
  background-color: #333;
  transition: 0.8s transform ease-in-out;
  transform-origin: left;
  cursor: pointer;
  box-shadow: inset 0 0 3px white, 5px 10px 20px rgba(0, 0, 0, 0.19), 5px 6px 6px rgba(0, 0, 0, 0.23);
  transform: rotateY(-25deg);
}

.door-fold.opened {
  transform: rotateY(-100deg);
}

.door-fold.sealed {
  transform: rotateY(0deg) !important;
  box-shadow: inset 0 0 3px white;
}

.door-fold.locked {
  cursor: default !important;
}

.door span {
  color: white;
  font-size: 3rem;
  font-family: 'Fascinate Inline', cursive, sans-serif;
  text-shadow: -1px 2px 6px #333, 1px 2px 6px #333;
  display: flex;
  width: 100%;
  height: 100%;
  text-align: center;
  justify-content: center;
  align-content: center;
  flex-direction: column;
}

.dialog-container {
  position: fixed;
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #555;
  cursor: pointer;
}

.dialog-image {
  max-width: 100vw;
  max-height: 100vh;
}

.dialog-description {
  position: absolute;
  z-index: 11;
  top: 1em;
  left: 1em;
  padding: .4em 1em;
  background-color: #282828;
  color: white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 1.2em;
  max-width: 92%;
  cursor: pointer;
  border-radius: 2em;
  box-sizing: border-box;
}

.dialog-shadow {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9;
}
</style>



// WEBPACK FOOTER //
// src/components/calendar.vue